import { memo } from 'react'
import { observer } from 'mobx-react'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { scrollToElement } from 'utils/pollard/scroll'
import { VOUCHER_ACTIVATION_BANNER_ID } from '../../VoucherBanner.constants'
import { VoucherBannerVariant } from '../../VoucherBanner.types'
import {
  BannerContainer,
  Illustration,
  TextContent,
  Title,
  Subtitle
} from './TopNotActivatedVoucherBanner.styles'
import { VARIANT_COPY } from './TopNotActivatedVoucherBanner.constants'

interface TopNotActivatedVoucherBannerProps {
  tenant: VoucherBannerVariant
  amount: number
  variant?: 'default' | 'var-b'
}

function TopNotActivatedVoucherBannerComponent({
  tenant,
  amount,
  variant = 'default'
}: TopNotActivatedVoucherBannerProps) {
  const { rootStore } = useRootStore()
  const { subtitle, illustration, title } = VARIANT_COPY[tenant]
  const resolvedSubtitle =
    variant === 'var-b' && tenant === 'smava' ? 'Jetzt bei smava.' : subtitle

  const handleNavigateToActivationBanner = () => {
    const el = document.getElementById(VOUCHER_ACTIVATION_BANNER_ID)
    if (!el) return
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    if (isSafari) {
      scrollToElement(el, rootStore.isInIframe)
    } else {
      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    }
  }

  return (
    <BannerContainer
      variant={tenant}
      clickable
      onClick={handleNavigateToActivationBanner}
    >
      <TextContent>
        <Illustration
          src={illustration}
          alt={`Illustration for ${tenant} voucher banner`}
          variant={tenant}
          aria-hidden="true"
        />
        <Title variant={tenant}>{title(amount)}</Title>
        <Subtitle variant={tenant}>{resolvedSubtitle}</Subtitle>
      </TextContent>
    </BannerContainer>
  )
}

export const TopNotActivatedVoucherBanner = memo(
  observer(TopNotActivatedVoucherBannerComponent)
)
